export default __webpack_public_path__ + "static/media/product_test_discovery_lyr.cb8fcb84.jpg";